<template>
  <td class="table--buttons">
    <slot/>
  </td>
</template>

<script>
  export default {
    name: 'TdButtons'
  }
</script>

<style lang="scss">
  .table--buttons {
    text-align: right;
    top: 0;
    display: flex;
    justify-content: flex-end;

    span {
      color: var(--white);
    }
    
    a {
      margin-right: 10px;
      font-weight: bold;

      &:last-child {
        margin-right: 0;
      }
    }
  }
</style>
